import React from "react"
import { translate } from "../../i18n"
import {
  AddMemberScreen,
  ChangeLanguageScreen,
  ChangePasswordScreen,
  ConnectedFarmScreen,
  DeleteAccountScreen,
  EditProfileScreen,
  InfoAppScreen,
  InterestScreen,
  MemberScreen,
  PasswordResetScreen,
  PolicyScreen,
  // ProfileScreen,
  SettingAccountScreen
} from "../../screens"
import { color } from "../../theme"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"

export type ProfileNavigatorParamList = {
  'Profile.Profile': undefined,
  'Profile.Connected.Farm': undefined,
  'Profile.Connected.Farm.Member': undefined,
  'Profile.Connected.Farm.Member.Add': undefined,
  'Profile.Change.Language': undefined,
  'Profile.Change.Interest': undefined,
  'Profile.Choose.Interest': undefined,
  'Profile.Change.Setting.Account': undefined,
  'Profile.Change.Setting.Account.Password': undefined,
  'Profile.Change.Setting.Account.Delete': undefined,
  'Profile.Change.Edit.Profile': undefined,
  'Profile.App.Info': undefined,
  'Profile.App.Policy': undefined,
  'Profile.Password.Reset': undefined,
}

// const Stack = createNativeStackNavigator<ProfileNavigatorParamList>()
const Stack = createStackNavigator<ProfileNavigatorParamList>()

export const ProfileStack = {
  index: 0,
  routes: [
    { name: 'Profile.Stack', state: { index: 0, routes: [{ name: 'Profile.Profile' }] } }
  ]
};

export const ProfileInterest = {
  index: 0,
  routes: [
    { name: 'Profile.Stack', state: { index: 0, routes: [{ name: 'Profile.Choose.Interest' }] } }
  ]
};

export const ProfileNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      // initialRouteName="Profile.Profile"
    >
      {/* <Stack.Screen name="Profile.Profile" component={ProfileScreen}
       options={{
         title: 'Profile',
         headerTitle: translate('profileScreen.profile'),
         headerShown: true,
         headerShadowVisible: false,
         headerStyle: { backgroundColor: color.primary },
         headerTintColor: color.palette.white
       }}
      /> */}
      <Stack.Screen name="Profile.Connected.Farm" component={ConnectedFarmScreen}
        options={{
          title: 'Connected Farm',
          headerTitle: translate('connectedFarm.header'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen name="Profile.Connected.Farm.Member" component={MemberScreen}
        options={{
          title: 'Farm Profile',
          headerTitle: translate('connectedFarm.member'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
       />
      <Stack.Screen name="Profile.Connected.Farm.Member.Add" component={AddMemberScreen}
        options={{
          title: 'Add Member',
          headerTitle: translate('connectedFarm.add'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Profile.Change.Language"
        component={ChangeLanguageScreen}
        options={{
          title: 'Profile / Change Language',
          headerTitle: translate('changeLanguage.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Change.Interest"
        component={InterestScreen}
        options={{
          title: 'Profile / Change Interest',
          headerTitle: translate('personalisationScreen.header'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Choose.Interest"
        component={InterestScreen}
        options={{
          title: '',
          headerShown: false,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.palette.white },
        }}
      />
      <Stack.Screen
        name="Profile.Change.Setting.Account"
        component={SettingAccountScreen}
        options={{
          title: 'Profile / Change Setting Account',
          headerTitle: translate('settingAccount.setting'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Change.Setting.Account.Password"
        component={ChangePasswordScreen}
        options={{
          title: 'Profile / Change Password',
          headerTitle: translate('settingAccount.changePassword'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Change.Setting.Account.Delete"
        component={DeleteAccountScreen}
        options={{
          title: 'Profile / Delete Account',
          headerTitle: translate('settingAccount.delete'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Change.Edit.Profile"
        component={EditProfileScreen}
        options={{
          title: 'Profile / Delete Account',
          headerTitle: translate('editProfileForm.header'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.App.Info"
        component={InfoAppScreen}
        options={{
          title: 'App Info',
          headerTitle: translate('infoAppScreen.title'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.App.Policy"
        component={PolicyScreen}
        options={{
          title: 'App Policy',
          headerTitle: translate('privacyPolicy'),
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
        }}
      />
      <Stack.Screen
        name="Profile.Password.Reset"
        component={PasswordResetScreen}
        options={{
          title: 'Password Reset',
          headerTitle: translate("passwordResetScreen.resetPassword"),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
    </Stack.Navigator>
  )
}
